// eslint-disable-next-line import-x/no-extraneous-dependencies
import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';
import Cookies from 'js-cookie';
import { getDataFromPocket } from '../../utils/pocket';
import { getClientIpSource, getClientJA3, getClientJA4 } from './utils-get-user-info';
import type { DLParams, JobParams, RCParams } from './utils-pocket-models';

interface MatomoOptions {
    baseUrl: string;
}

export async function initMatomo() {
    const opts = getDataFromPocket<MatomoOptions>('matomo')!;

    // Script init
    // eslint-disable-next-line no-underscore-dangle
    window._paq = window._paq ?? [];

    // eslint-disable-next-line no-underscore-dangle
    const matomoDataLayer = window._paq;

    const { thumbmark: userId } = await (new Thumbmark()).get();

    matomoDataLayer.push(['setCookieDomain', '*.acronis.com']);
    matomoDataLayer.push(['setDomains', ['*.acronis.com', '*.acronis.events', '*.trueimage.com']]);
    matomoDataLayer.push(['enableCrossDomainLinking']);
    matomoDataLayer.push(['disableCookies']);
    matomoDataLayer.push(['enableLinkTracking']);
    matomoDataLayer.push(['setTrackerUrl', `${opts.baseUrl}/mat/matomo.php`]);
    matomoDataLayer.push(['setSiteId', '1']);
    matomoDataLayer.push(['setUserId', userId]);

    const script = document.createElement('script');
    script.async = true;
    script.src = `${opts.baseUrl}/mat/matomo.js`;
    const targetNode = document.getElementsByTagName('script')[0]!;
    targetNode.parentNode!.insertBefore(script, targetNode);

    // Pageview event
    const getBrowserDimensions = () => {
        function roundToNearestHundred(value: number): number {
            return Math.round(value / 100) * 100;
        }

        const width = roundToNearestHundred(window.innerWidth);
        const height = roundToNearestHundred(window.innerHeight);

        return `${width},${height}`;
    };

    const getSiteLocale = () => {
        const match = window.location.pathname.match(/^[/]([a-z][a-z]-[a-z][a-z])[/]/);
        return match && match[1] ? match[1] : null;
    };

    const dlParams = getDataFromPocket<DLParams>('ga_dl_params', false) || {};
    const rcParams = getDataFromPocket<RCParams>('ga_rc_params', false) || {};
    const jobParams = getDataFromPocket<JobParams>('ga_job_params', false) || {};

    const dimensions = [
        { id: 2, val: Cookies.get('AcronisUID.en') },
        { id: 6, val: getBrowserDimensions() },
        { id: 5, val: window.devicePixelRatio?.toFixed(2) },
        { id: 14, val: getSiteLocale() },
        { id: 1, val: dlParams.DL_PageType },
        { id: 3, val: dlParams.DL_Audience },
        { id: 4, val: dlParams.DL_Product },
        { id: 15, val: rcParams.rcCategory },
        { id: 16, val: rcParams.rcFeatured },
        { id: 17, val: rcParams.rcProduct },
        { id: 18, val: rcParams.rcType },
        { id: 19, val: jobParams.pageDetailsA },
        { id: 20, val: jobParams.pageDetailsB },
        { id: 21, val: jobParams.pageDetailsC },
        { id: 22, val: getClientIpSource() },
        { id: 23, val: getClientJA3() },
        { id: 24, val: getClientJA4() },
    ];

    dimensions
        .filter(({ val }) => val !== undefined && val !== null && val !== '(not set)' && val.toString().trim())
        .forEach((dim) => matomoDataLayer.push(['setCustomDimension', dim.id, dim.val]));

    matomoDataLayer.push(['trackPageView']);
}
